import { useEffect, useRef, useState } from "react";
import axios from "../api/axios";
import { useReactToPrint } from 'react-to-print';
import { FilePdfOutlined } from "@ant-design/icons";
import Select from "react-select";
import { Button, Row, Col, Modal, message, Alert } from "antd";
import { CheckCircleOutlined, ClockCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import Annex2a from "./RCC_APR_ReportTablesComponents/Annex2a";
import Annex2b from "./RCC_APR_ReportTablesComponents/Annex2b";
import Annex3b from "./RCC_APR_ReportTablesComponents/Annex3b";
import Annex3c from "./RCC_APR_ReportTablesComponents/Annex3c";
import Annex4a from "./RCC_APR_ReportTablesComponents/Annex4a";
import Annex5a from "./RCC_APR_ReportTablesComponents/Annex5a";
import Annex6a from "./RCC_APR_ReportTablesComponents/Annex6a";
import Annex7a from "./RCC_APR_ReportTablesComponents/Annex7a";
import Annex7c from "./RCC_APR_ReportTablesComponents/Annex7c";
import Annex8a from "./RCC_APR_ReportTablesComponents/Annex8a";
import Annex8b from "./RCC_APR_ReportTablesComponents/Annex8b";
import Annex8c from "./RCC_APR_ReportTablesComponents/Annex8c";
import Annex9a from "./RCC_APR_ReportTablesComponents/Annex9a";

import ReportCover from "./APR_ReportTablesComponents/ReportCover";
import useAuth from "../hooks/useAuth";
import instance from "../api/cmsapi";
import { useLocationContext } from "../context/LocationContext";
import WorkFlowComponent from "./RCC_APR_ReportTablesComponents/APRComment.js/WorkFlowComponent";
import Annex5b from "./RCC_APR_ReportTablesComponents/Annex5b";
import { set } from "date-fns";

// List of Tables options
const tableOptions = [
  { value: "all_tables", label: "All Tables" },
  { value: "table_1", label: "Annex 2a – Details on the RCC Annual Action Plan Implemented" },
  { value: "table_2", label: "Annex 2b – Proportion of the MTDP implemented" },
  { value: "table_3", label: "Annex 3b – Repair and Maintenance of Existing Infrastructure" },
  { value: "table_4", label: "Annex 3c – Register of Key Regional Programmes" },
  { value: "table_5", label: "Annex 4a – Update On Revenue Sources and Expenditure" },
  { value: "table_5b", label: "Annex 5b – Update On Human Resource Issues and Logistics" },
  { value: "table_6", label: "ANNEX 5a – Update on Expenditure" },
  { value: "table_7", label: "Annex 6a – Regional Performance of Core Indicators" },
  { value: "table_8", label: "Table 8 – Updates on Critical Development and Poverty Issues in the Year 2025" },
  { value: "table_9", label: "Table 9 – Staff Development (Capacity Building /Training)" },
  { value: "table_10", label: "Table 10 – Staff Strength of the RCC" },
  { value: "table_11", label: "Table 11 – Update on key Logistics" },
  { value: "table_12", label: "Table 12 – Evaluations Conducted, their findings and Recommendations" },
  { value: "table_13", label: "ANNEX 9: UPDATE ON PM&E CONDUCTED" },
];

const periodOption = [
  { value: "Q1", label: "First Quarter - Q1" },
  { value: "Q2", label: "Second Quarter - Q2" },
  { value: "Q3", label: "Third Quarter - Q3" },
  { value: "Q4", label: "Fourth Quarter - Q4" },
  { value: "Y", label: "Yearly" }
];

const Abbreviation = [
  { value: "1D1F", label: "1D1F - One District One Factory" },
  { value: "AAP", label: "AAP - Annual Action Plan" },
  { value: "AIDS", label: "AIDS - Acquired Immune Deficiency Syndrome" },
  { value: "AMSEC", label: "AMSEC - Agricultural Mechanisation Services" },
  { value: "APR", label: "APR - Annual Progress Report" },
  { value: "ART", label: "ART - Anti-Retroviral Treatment" },
  { value: "BECE", label: "BECE - Basic Education Certificate Examination" },
  { value: "CAPEX", label: "CAPEX - Capital Expenditure" },
  { value: "CLTS", label: "CLTS - Community Led Total Sanitation" },
  { value: "CHPS", label: "CHPS - Community-Based Health Planning and Services" },
  { value: "COVID", label: "COVID - Corona Virus Disease" },
  { value: "CSOs", label: "CSOs - Civil Society Organisations" },
  { value: "DACF", label: "DACF - District Assemblies’ Common Fund" },
  { value: "DACF-RFG", label: "DACF-RFG - District Assemblies’ Common Fund Responsiveness Factor Grant" },
  { value: "EXECO", label: "EXECO - Executive Committee" },
  { value: "GHS", label: "GHS - Ghana Cedis" },
  { value: "GoG", label: "GoG - Government of Ghana" },
  { value: "HIV", label: "HIV - Human Immunodeficiency Virus" },
  { value: "HoDs", label: "HoDs - Head of Departments" },
  { value: "IGF", label: "IGF - Internally Generated Fund" },
  { value: "ISSOP", label: "ISSOP - Integrated Social Services Operating Procedure" },
  { value: "JHS", label: "JHS - Junior High School" },
  { value: "LEAP", label: "LEAP - Livelihood Empowerment Against Poverty" },
  { value: "LLINs", label: "LLINs - Long-Lasting Insecticidal Nets" },
  { value: "MAC", label: "MAC - Municipal AIDS Committee" },
  { value: "MAG", label: "MAG - Modernising Agriculture in Ghana" },
  { value: "MCD", label: "MCD - Municipal Co-ordinating Director" },
  { value: "MCE", label: "MCE - Municipal Chief Executive" },
  { value: "M&E", label: "M&E - Monitoring and Evaluation" },
  { value: "MMTDP", label: "MMTDP - Municipal Medium-Term Development Plan" },
  { value: "MP’s CF", label: "MP’s CF - Member of Parliament’s Common Fund" },
  { value: "MPCU", label: "MPCU - Municipal Planning Coordinating Unit" },
  { value: "MSEs", label: "MSEs - Micro and Small Enterprises" },
  { value: "MTDP", label: "MTDP - Medium-Term Development Plan" },
  { value: "MUSEC", label: "MUSEC - Municipal Security Council" },
  { value: "NDPC", label: "NDPC - National Development Planning Commission" },
  { value: "NGOs", label: "NGOs - Non-Governmental Organizations" },
  { value: "NHIS", label: "NHIS - National Health Insurance Scheme" },
  { value: "NSMA", label: "NSMA - Nkwanta South Municipal Assembly" },
  { value: "ORCC", label: "ORCC - Oti Regional Coordinating Council" },
  { value: "PERD", label: "PERD - Planting for Export and Rural Development" },
  { value: "PM&E", label: "PM&E - Participatory Monitoring and Evaluation" },
  { value: "PMTCT", label: "PMTCT - Prevention of Mother to Child Transmission" },
  { value: "PWDs", label: "PWDs- Persons With Disabilities" },
  { value: "SHS", label: "SHS - Senior High School" },
  { value: "SOCO", label: "SOCO - Gulf of Guinea Northern Regions Social Cohesion Project" },
  { value: "SPSS", label: "SPSS - Scientific Package for Social Scientist" },
];

function resolveContextDistrict(currentLocation, orgTree) {
  if (!currentLocation) return null;

  if (currentLocation.level === "region") {
    return { value: currentLocation.orgUnitId, label: currentLocation.name }
  }

  return null;
}

function getRegionName(currentLocation) {
  if (!currentLocation) return null;

  return currentLocation.level === "region" ? currentLocation.name : null;
}

function AprReport({ embedded = false }) {

  const [dataElements, setDataElements] = useState(null);
  const [economicDataElements, setEconomicDataElements] = useState(null);
  const [socialDataElements, setSocialDataElements] = useState(null);
  const [categories, setCategories] = useState(null);
  const [districtWideConstant, setDistrictWideConstant] = useState(null);
  const [districts, setDistricts] = useState(null);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [selectedYear, setSelectedYear] = useState({ value: "2025", label: "2025" });
  const [selectedPeriod, setSelectedPeriod] = useState({ value: "Y", label: "Yearly" });
  const [selectedABB, setSelectedABB] = useState({ value: "Abbreviation", label: "List of Abbreviations" });
  const [selectedTocSection, setSelectedTocSection] = useState(null);
  const contentToPrint = useRef(null);
  const [progressLoad, setProgressLoad] = useState(false);

  const [assessmentStatus, setAssessmentStatus] = useState(null);
  const { user } = useAuth();
  const { currentLocation, orgTree } = useLocationContext();
  const currentUserRole = user?.user?.userRoles?.find(
    (role) => role.name === "APR USER" || role.name === "RCC USER" || role.name === "NDPC USER"
  )?.name || "";

  const normalizedUserRole = currentUserRole ? currentUserRole.replace(" ", "_").toUpperCase() : "";

  const rccUserRole = user?.user?.userRoles?.find((role) => role.name === "RCC USER" || role.name === "Superuser") || null;

  // Set "All Tables" as the default selected table
  const [selectedTable, setSelectedTable] = useState({ value: "all_tables", label: "All Tables" });

  // Year options for dropdown
  const yearOptions = (() => {
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 5;
    return Array.from({ length: 6 }, (_, i) => {
      const year = startYear + i;
      return { value: year.toString(), label: year.toString() };
    });
  })();

  // Helper function to format period for filename
  const getPeriodLabel = () => {
    if (selectedPeriod?.value === "yearly") {
      return "Annual";
    }
    return selectedPeriod?.label?.split(" - ")[0] || selectedPeriod?.value || "Yearly";
  };

  // Notification configuration based on assessment status
  const getNotificationConfig = () => {
    if (!assessmentStatus) return null;
    
    switch (assessmentStatus.status) {
      case "Pending":
        return {
          type: "warning",
          icon: <ClockCircleOutlined />,
          message: "Report Status: Pending",
          description: "This report has been started but not yet submitted. Please complete and submit to NDPC.",
          show: true
        };
      case "Completed":
        return {
          type: "success",
          icon: <CheckCircleOutlined />,
          message: "Report Status: Completed",
          description: "This report has been submitted to NDPC successfully.",
          show: true
        };
      case "Closed":
        return {
          type: "error",
          icon: <CloseCircleOutlined />,
          message: "Report Status: Closed",
          description: "This report has been closed. No further changes can be made.",
          show: true
        };
      default:
        return null;
    }
  };

  const notificationConfig = getNotificationConfig();

  useEffect(() => {
    if (!embedded) return;

    const nextDistrict = resolveContextDistrict(currentLocation, orgTree);
    const regionName = getRegionName(currentLocation);

    setSelectedRegion(regionName);

    setSelectedDistrict((previousDistrict) => {
      if (
        previousDistrict?.value === nextDistrict?.value &&
        previousDistrict?.label === nextDistrict?.label
      ) {
        return previousDistrict;
      }
      return nextDistrict;
    });
  }, [embedded, currentLocation, orgTree]);


  useEffect(() => {
    const fetchAssessmentStatus = async () => {
      try {
        const response = await instance.get(
          `assessments/dpat/${selectedDistrict?.value}/${selectedYear?.value}/RCC_APR_${selectedPeriod?.value || "Y"}`
        );
        setAssessmentStatus(response.data);
      } catch (error) {
        console.error("Failed to fetch assessment status:", error);
        setAssessmentStatus(null);
      }
    };

    if (selectedDistrict?.value && selectedYear?.value) {
      fetchAssessmentStatus();
    } else {
      setAssessmentStatus(null);
    }
  }, [selectedDistrict, selectedYear]);

  useEffect(() => {
    pullConstantData();
  }, []);

  useEffect(() => {
    if (!embedded) {
      getData();
    }
  }, [embedded]);

  useEffect(() => {
    if (selectedDistrict && selectedYear) {
      getDistrictWideConstant(selectedDistrict.value, selectedYear.value)
    }
  }, [selectedDistrict, selectedYear]);

  // Updated handlePrint with year and period in filename
  const handlePrint = useReactToPrint({
    content: () => contentToPrint.current,
    documentTitle: `${selectedDistrict?.label || "RCC"}_APR_Report_${selectedYear?.value || "Year"}_${getPeriodLabel()}`,
    onBeforeGetContent: () => {
      // Fix any zero-dimension canvases before printing
      const canvases = document.querySelectorAll('canvas');
      canvases.forEach(canvas => {
        if (canvas.width === 0 || canvas.height === 0) {
          canvas.width = 800;
          canvas.height = 400;
          canvas.style.width = '800px';
          canvas.style.height = '400px';
        }
      });
      return Promise.resolve();
    },
    onBeforePrint: () => console.log("before printing..."),
    onAfterPrint: () => console.log("after printing..."),
    onPrintError: (error) => {
      console.error("Print error:", error);
      message.error("Failed to generate PDF. Please try again.");
    },
    removeAfterPrint: true,
  });

  function pullConstantData() {
    axios.get('/dataSets/saljkJMizBZ?fields=dataSetElements[dataElement[id,name]]&paging=false')
      .then(response => {
        setDataElements(response.data.dataSetElements);
      }).catch(err => {
        console.error("Error pulling Data Elements: ", err);
      });

    axios.get('/dataSets/Xj0f6QZwYeO?fields=dataSetElements[dataElement[id,name]]&paging=false')
      .then(response => {
        setEconomicDataElements(response.data.dataSetElements);
      }).catch(err => {
        console.error("Error pulling Data Elements: ", err);
      });

    axios.get('/dataSets/cfMIscR3rdL?fields=dataSetElements[dataElement[id,name]]&paging=false')
      .then(response => {
        setSocialDataElements(response.data.dataSetElements);
      }).catch(err => {
        console.error("Error pulling Data Elements: ", err);
      });

    axios.get('/categoryOptionCombos.json?fields=id,name&paging=false')
      .then(response => {
        setCategories(response.data.categoryOptionCombos);
      }).catch(err => {
        console.error("Error pulling Category Combination:", err);
      });
  }

  function getDistrictWideConstant(district, year) {
    axios
      .get(`/dataValueSets?dataSet=saljkJMizBZ&orgUnit=${district}&startDate=${year}-01-01&endDate=${year}-12-31`)
      .then(result => {
        setDistrictWideConstant(result.data.dataValues);
      })
      .catch(err => {
        console.log(err);
      });
  }

  function getData() {
    const storedDistricts = localStorage.getItem("districts");
    if (storedDistricts) {
      const parsedDistricts = JSON.parse(storedDistricts);
      setDistricts(parsedDistricts);
      if (parsedDistricts.length > 0 && !selectedDistrict) {
        setSelectedDistrict(parsedDistricts[0]);
      }
      return;
    }

    axios
      .get("https://dddp.gov.gh/api/organisationUnits?level=3&paging=false")
      .then((result) => {
        let temp = [];
        result.data.organisationUnits.forEach((district) => {
          const currentDistrict = { value: district.id, label: district.displayName };
          temp.push(currentDistrict);
        });

        localStorage.setItem("districts", JSON.stringify(temp));
        setDistricts(temp);
        if (temp.length > 0 && !selectedDistrict) {
          setSelectedDistrict(temp[0]);
        }
      })
      .catch((err) => console.log(err));
  }


  const handleStartAPR = async () => {
    setProgressLoad(true);

    const payload = {
      id: 0,
      username: user?.user?.username || "",
      fullName: user?.user?.fullName || "",
      userRole: rccUserRole ? rccUserRole.name : "",
      type: `RCC_APR_${selectedPeriod?.value || "Y"}`,
      districtId: selectedDistrict?.value || "",
      year: selectedYear?.value || "",
      status: "Pending",
      assessmentStartDate: new Date().toISOString().split("T")[0],
      assessmentEndDate: null,
      reviewStartDate: null,
      reviewEndDate: null,
      closedDate: null,
    };

    try {
      const assessmentResponse = await instance.post(`assessments`, payload);
      setAssessmentStatus(assessmentResponse.data);
      message.success({
        content: (
          <div>
            <p>Assessment started successfully</p>
          </div>
        ),
        duration: 3,
      });

    } catch (error) {
      console.error("Failed to process report or comment:", {
        // message: error.message,
        response: error.response?.data,
        status: error.response?.status,
      });
      // message.error(`Failed to process: ${error.response?.data?.message || error.message}`);
    } finally {
      setProgressLoad(false);
    }
  };


  const handleCompleteAPR = async () => {
    setProgressLoad(true);
    const reviewEndDate = new Date().toISOString().split("T")[0];
    const assessmentEndDate = new Date().toISOString().split("T")[0];
    const assessmentStartDate = assessmentStatus?.assessmentStartDate || new Date().toISOString().split("T")[0]; // Use existing start date or fallback to today

    const payload = {
      id: assessmentStatus.id,
      username: user?.user?.username,
      fullName: user?.user?.fullName,
      userRole: normalizedUserRole,
      // userRole: "DDDP_USER",
      type: assessmentStatus.type,
      districtId: selectedDistrict?.value,
      year: assessmentStatus.year,
      status: "Completed",
      assessmentStartDate: assessmentStartDate,
      assessmentEndDate: assessmentEndDate,
      reviewStartDate: assessmentStatus?.reviewStartDate || assessmentEndDate, // Use existing review start date or fallback to assessmentEndDate
      reviewEndDate: reviewEndDate,
      closedDate: null,
    };


    try {
      // Step 1: Update assessment with PUT request
      const response = await instance.put(`assessments/${payload.id}`, payload);
      setAssessmentStatus(response.data);
      message.success({
        content: (
          <div>
            <p>Submitted Successfully </p>
          </div>
        ),
        duration: 3,
      });


    } catch (error) {
      console.error("Failed to Submit Report:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
      });
      message.error(`Failed to Submit Report: ${error.response?.data?.message || error.message}`);
    } finally {
      setProgressLoad(false);
    }
  };

  const handleCloseAPR = async () => {
    // Keep your existing implementation
  };

  const handleTableSelection = (selectedOption) => {
    setSelectedTable(selectedOption);
    // No data reloading here - just updating the selected table state
  };

  const showConfirm = () => {
    Modal.confirm({
      title: 'Start Report',
      content: `Do you want to start the Progress Report for this region ?`,
      okText: 'Yes',
      cancelText: 'No',
      onOk() {
        handleStartAPR();
      },
      onCancel() {
        // Do nothing on cancel
      },
    });
  };

  const showCompleted = () => {
    Modal.confirm({
      title: 'SUBMIT APR TO NDPC',
      content: `Do you want to submit your final progress report to NDPC for this Region ?`,
      okText: 'Yes',
      cancelText: 'No',
      onOk() {
        handleCompleteAPR();
      },
      onCancel() {
        // Do nothing on cancel
      },
    });
  };

  const showClosed = () => {
    Modal.confirm({
      title: 'CLOSE PROGRESS REPORT',
      content: `Do you want to close progress report for this district?`,
      okText: 'Yes',
      cancelText: 'No',
      onOk() {
        handleCloseAPR();
      },
      onCancel() {
        // Do nothing on cancel
      },
    });
  };

  const hasSelectedDistrict = Boolean(selectedDistrict?.value);
  const hideTableDis = !assessmentStatus || assessmentStatus?.status === "Pending" || assessmentStatus?.status === "Completed" || assessmentStatus?.status === "Closed";
  const workflowStatus = assessmentStatus?.status || "Not started";
  const statusBadgeClassName =
    assessmentStatus?.status === "Closed"
      ? "border-destructive/20 bg-destructive/10 text-destructive"
      : assessmentStatus?.status === "Completed"
        ? "border-success/20 bg-success/10 text-success"
        : assessmentStatus?.status === "Pending"
          ? "border-warning/20 bg-warning/10 text-warning"
          : assessmentStatus?.status === "Start"
            ? "border-primary/20 bg-primary/10 text-primary"
            : "border-border bg-muted text-muted-foreground";
  const currentWorkspaceLabel =
    selectedTable?.value === "all_tables" ? "All APR tables" : selectedTable?.label || "APR workspace";
  const buttonTextStyle = { color: "white", fontSize: "14px", fontWeight: "bold" };
  const actionButtonSpacing = embedded ? {} : { marginTop: "10px" };
  const emptyDistrictMessage = embedded
    ? "Select a district from the left sidebar to load the APR workspace."
    : "Select a district to load the APR workspace.";

  const startReportAction =
    (hasSelectedDistrict && assessmentStatus === null && rccUserRole !== null)
      ? (
        <Button
          type="primary"
          onClick={showConfirm}
          style={{
            backgroundColor: "#1890ff",
            borderColor: "#1890ff",
            ...actionButtonSpacing,
          }}
          loading={progressLoad}
        >
          <span style={buttonTextStyle}>Start RCC Progress Report</span>
        </Button>
      ) : null;

  const submitToNdpcAction =
    (hasSelectedDistrict && assessmentStatus?.status === "Pending" && rccUserRole !== null) ? (
      <Button
        type="primary"
        onClick={showCompleted}
        style={{
          backgroundColor: "#048311ff",
          borderColor: "#048311ff",
          ...actionButtonSpacing,
        }}
        loading={progressLoad}
      >
        <span style={buttonTextStyle}>Submit Progress Report to NDPC</span>
      </Button>
    ) : null;

  const closeReportAction = (hasSelectedDistrict && assessmentStatus?.status === "Completed" && rccUserRole !== null) ? (
      <Button
        type="primary"
        onClick={showClosed}
        style={{
          backgroundColor: "#b60000ff",
          borderColor: "#b60000ff",
          ...actionButtonSpacing,
        }}
        loading={progressLoad}
      >
        <span style={buttonTextStyle}>Close Current RCC Progress Report</span>
      </Button>
    ) : null;

  const downloadReportAction = (
    <Button
      type="primary"
      icon={<FilePdfOutlined style={{ fontSize: "20px", color: "white", fontWeight: "bold" }} />}
      onClick={() => {
        if (contentToPrint.current) {
          handlePrint();
        } else {
          console.log("Content is not available for printing.");
        }
      }}
      disabled={!selectedDistrict}
      style={{
        backgroundColor: "#1890ff",
        borderColor: "#1890ff",
        height: "35px",
        padding: "0 15px",
        ...actionButtonSpacing,
      }}
    >
      <span style={buttonTextStyle}>Download PDF</span>
    </Button>
  );

  // All components are always rendered but controlled via CSS display property
  const reportContent = (
    <>
      <style>
        {`
          .apr-report-page .card > .card-body {
            padding-left: 0 !important;
            padding-right: 0 !important;
          }
        `}
      </style>
      {embedded ? (
        <div className="rounded-2xl border border-border bg-card p-6 shadow-sm">
          <div className="flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between">
            <div className="space-y-2">
              <p className="text-xs font-semibold uppercase tracking-[0.12em] text-muted-foreground">
                Progress Report
              </p>
              <div>
                <h1 className="text-2xl font-semibold text-foreground md:text-3xl">
                  Annual Progress Report
                </h1>
                <p className="mt-1 max-w-2xl text-sm text-muted-foreground">
                  Prepare, review, submit and export APR of {selectedDistrict?.label || "Select in sidebar"} for the selected period.
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
              <div className="rounded-xl border border-border bg-background px-4 py-3">
                <p className="text-xs font-semibold uppercase tracking-[0.1em] text-muted-foreground">Year</p>
                <p className="mt-1 text-sm font-medium text-foreground">{selectedYear?.value || "Not selected"}</p>
              </div>
              <div className="rounded-xl border border-border bg-background px-4 py-3">
                <p className="text-xs font-semibold uppercase tracking-[0.1em] text-muted-foreground">Region</p>
                <p className="mt-1 text-sm font-medium text-foreground">{selectedDistrict?.label || "Select in sidebar"}</p>
              </div>
              <div className="rounded-xl border border-border bg-background px-4 py-3">
                <p className="text-xs font-semibold uppercase tracking-[0.1em] text-muted-foreground">Workflow</p>
                <span className={`mt-1 inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-medium ${statusBadgeClassName}`}>
                  {workflowStatus}
                </span>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="page-header">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">Home</li>
            <li className="breadcrumb-item active">Annual Progress Report (APR)</li>
          </ol>
        </div>
      )}

      {/* Notification Section - Shows at the top when assessment exists */}
      {hasSelectedDistrict && notificationConfig && notificationConfig.show && (
        <div className={embedded ? "mt-4" : "mt-3"}>
          <Alert
            message={notificationConfig.message}
            description={notificationConfig.description}
            type={notificationConfig.type}
            showIcon
            icon={notificationConfig.icon}
            closable
            style={{
              marginBottom: "16px",
              borderLeft: `4px solid ${
                notificationConfig.type === "success" ? "#52c41a" : 
                notificationConfig.type === "warning" ? "#faad14" : "#ff4d4f"
              }`,
            }}
          />
        </div>
      )}

      <div className={embedded ? "space-y-6" : "main-container"}>
        <div className={embedded ? "rounded-2xl border border-border bg-card p-5 shadow-sm" : ""}>
          <div className={embedded ? "grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-5" : "row gutters mb-3"}>
            <div className={embedded ? "space-y-2" : "col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12"}>
              {embedded && (
                <label className="text-xs font-semibold uppercase tracking-[0.1em] text-muted-foreground">
                  Year
                </label>
              )}
              <Select
                onChange={(val) => setSelectedYear(val)}
                options={yearOptions}
                value={selectedYear}
                placeholder="Select Year"
                isSearchable
              />
            </div>

            <div className={embedded ? "space-y-2" : "col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12"}>
              {embedded && (
                <label className="text-xs font-semibold uppercase tracking-[0.1em] text-muted-foreground">
                  Period
                </label>
              )}
              <Select
                onChange={setSelectedPeriod}
                options={periodOption}
                value={selectedPeriod}
                placeholder="Select Report Period"
              />
            </div>

            <div className={embedded ? "space-y-2" : "col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12"}>
              {embedded && (
                <label className="text-xs font-semibold uppercase tracking-[0.1em] text-muted-foreground">
                  Table
                </label>
              )}
              <Select
                onChange={handleTableSelection}
                options={tableOptions}
                value={selectedTable}
                isSearchable
                placeholder="Select Table"
              />
            </div>

            <div className={embedded ? "space-y-2" : "col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12"}>
              {embedded && (
                <label className="text-xs font-semibold uppercase tracking-[0.1em] text-muted-foreground">
                  Abbreviations
                </label>
              )}
              <Select
                onChange={setSelectedABB}
                options={Abbreviation}
                value={selectedABB}
                isSearchable
                placeholder="Select Abbreviation"
              />
            </div>
          </div>
        </div>

        <div className={embedded ? "rounded-2xl border border-border bg-card p-5 shadow-sm" : ""}>
          {embedded && (
            <div className="mb-5 flex flex-col gap-3 border-b border-border pb-4 lg:flex-row lg:items-center lg:justify-between">
              <div>
                <p className="text-xs font-semibold uppercase tracking-[0.12em] text-muted-foreground">
                  Report Workspace
                </p>
                <h2 className="mt-1 text-lg font-semibold text-foreground">{currentWorkspaceLabel}</h2>
              </div>
              <p className="text-sm text-muted-foreground">
                {selectedDistrict?.label || "Select a district"} / {selectedYear?.value || "Year"} / {selectedPeriod?.label || "Period"}
              </p>
            </div>
          )}

          <div className={embedded ? "space-y-5" : "row gutters mb-3"}>
            {embedded ? (
              <div className="flex flex-wrap items-center gap-3">
                {startReportAction}
                {submitToNdpcAction}
                {closeReportAction}
                <div className="sm:ml-auto">{downloadReportAction}</div>
              </div>
            ) : (
              <>
                <Col span={10} className="gutter-row">
                  {startReportAction}
                </Col>
              </>
            )}

            {!hasSelectedDistrict && (
              <div className={embedded ? "rounded-2xl border border-dashed border-border bg-muted/20 p-6 text-sm text-muted-foreground" : "card"}>
                {embedded ? (
                  <p>{emptyDistrictMessage}</p>
                ) : (
                  <div className="card-body">
                    <p>{emptyDistrictMessage}</p>
                  </div>
                )}
              </div>
            )}

            {hasSelectedDistrict && (
              <div ref={contentToPrint}>
                {/* Report Cover - always visible */}
                <div className="row gutters">
                  {selectedDistrict && selectedYear && (
                    <ReportCover
                      district={selectedDistrict}
                      year={selectedYear?.value}
                      period={selectedPeriod?.label}
                      locationType="Region" />
                  )}
                </div>

                {assessmentStatus &&
                  <>
                    {(
                      <>
                        <WorkFlowComponent
                          year={selectedYear?.value}
                          district={selectedDistrict?.value}
                          hideTableDis={hideTableDis}
                          assessmentStatus={assessmentStatus}
                          tableCommented={`RCC_APR_Executive_${selectedPeriod?.value}`}
                          type={'RCC_APR'}
                          userRole={rccUserRole}
                          item="Executive Summary"
                        />
                      </>
                    )}


                    <h2 style={{ textAlign: "center" }}>CHAPTER ONE (1)</h2>
                    {(
                      <>
                        <WorkFlowComponent
                          year={selectedYear?.value}
                          district={selectedDistrict?.value}
                          hideTableDis={hideTableDis}
                          assessmentStatus={assessmentStatus}
                          tableCommented={`RCC_APR_GInformation_${selectedPeriod?.value}`}
                          type={'RCC_APR'}
                          userRole={rccUserRole}
                          item="General Information"
                        />
                      </>
                    )}</>}

                {/* All Tables - visible only when "all_tables" is selected */}
                <div style={{ display: selectedTable?.value === "all_tables" ? "block" : "none" }}>
                  <Annex2a
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                    assessmentStatus={assessmentStatus?.status === "Pending"}
                    assessmentStatus1={assessmentStatus?.status !== "Closed"}
                    normalizedUserRole={normalizedUserRole?.status === "NDPC USER"}
                  />

                  <Annex2b
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                  />

                  <h2 style={{ textAlign: "center" }}>CHAPTER TWO (2)</h2>

                  <Annex3b
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                  />

                  <Annex3c
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                  />

                  <Annex4a
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                  />

                  <Annex5a
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                  />

                  <Annex5b
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                    regionName={selectedRegion}
                  />

                  <Annex7c
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                  />

                  {(dataElements && categories && districtWideConstant) && (
                    <Annex6a
                      year={selectedYear?.value}
                      district={selectedDistrict?.value}
                      categories={categories}
                      dataElements={dataElements}
                      districtWideConstant={districtWideConstant}
                      economicDataElements={economicDataElements}
                      socialDataElements={socialDataElements}
                      period={selectedPeriod?.value}
                      hideTableDis={hideTableDis}
                    />
                  )}

                  <Annex7a
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                  />


                  <Annex8a
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                  />

                  <Annex8b
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                  />

                  <Annex8c
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                  />

                  <Annex9a
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                  />

                  {assessmentStatus && (
                    <>
                      <h2 style={{ textAlign: "center" }}>CHAPTER THREE (3)</h2>

                      <WorkFlowComponent
                        year={selectedYear?.value}
                        district={selectedDistrict?.value}
                        hideTableDis={hideTableDis}
                        assessmentStatus={assessmentStatus}
                        tableCommented={`RCC_APR_Introduction_${selectedPeriod?.value}`}
                        type={'RCC_APR'}
                        userRole={rccUserRole}
                        item="Introduction"
                      />

                      <WorkFlowComponent
                        year={selectedYear?.value}
                        district={selectedDistrict?.value}
                        hideTableDis={hideTableDis}
                        assessmentStatus={assessmentStatus}
                        tableCommented={`RCC_APR_KeyIssues_Addressed_${selectedPeriod?.value}`}
                        type={'RCC_APR'}
                        userRole={rccUserRole}
                        item="Key Issues Addressed"
                      />

                      <WorkFlowComponent
                        year={selectedYear?.value}
                        district={selectedDistrict?.value}
                        hideTableDis={hideTableDis}
                        assessmentStatus={assessmentStatus}
                        tableCommented={`RCC_APR_KeyIssuesYetToBe_Addressed_${selectedPeriod?.value}`}
                        type={'RCC_APR'}
                        userRole={rccUserRole}
                        item="Key Issues Yet to be Addressed"
                      />

                      <WorkFlowComponent
                        year={selectedYear?.value}
                        district={selectedDistrict?.value}
                        hideTableDis={hideTableDis}
                        assessmentStatus={assessmentStatus}
                        tableCommented={`RCC_APR_Recommendations_${selectedPeriod?.value}`}
                        type={'RCC_APR'}
                        userRole={rccUserRole}
                        item="Recommendations"
                      />

                      <WorkFlowComponent
                        year={selectedYear?.value}
                        district={selectedDistrict?.value}
                        hideTableDis={hideTableDis}
                        assessmentStatus={assessmentStatus}
                        tableCommented={`RCC_APR_Conclusion_${selectedPeriod?.value}`}
                        type={'RCC_APR'}
                        userRole={rccUserRole}
                        item="Conclusion"
                      />

                     {assessmentStatus?.status === "Completed" ? <WorkFlowComponent
                        year={selectedYear?.value}
                        district={selectedDistrict?.value}
                        hideTableDis={hideTableDis}
                        assessmentStatus={assessmentStatus}
                        tableCommented={`RCC_APR_NDPCSummary_${selectedPeriod?.value}`}
                        type={'RCC_APR'}
                        userRole={rccUserRole}
                        item="NDPC Summary of RCC Progress Report"
                      />: <></>}

                    </>)}
                </div>

                {/* Individual Tables - each visible only when its specific table is selected */}
                <div style={{ display: selectedTable?.value === "table_1" ? "block" : "none" }}>
                  <Annex2a
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                    assessmentStatus={assessmentStatus?.status === "Pending"}
                    assessmentStatus1={assessmentStatus?.status !== "Closed"}
                    normalizedUserRole={normalizedUserRole?.status === "NDPC USER"}
                  />
                </div>

                <div style={{ display: selectedTable?.value === "table_2" ? "block" : "none" }}>
                  <Annex2b
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                  />
                </div>

                <div style={{ display: selectedTable?.value === "table_3" ? "block" : "none" }}>
                  <Annex3b
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                  />
                </div>

                <div style={{ display: selectedTable?.value === "table_4" ? "block" : "none" }}>
                  <Annex3c
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                  />
                </div>

                <div style={{ display: selectedTable?.value === "table_5" ? "block" : "none" }}>
                  <Annex4a
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                  />
                </div>

                <div style={{ display: selectedTable?.value === "table_6" ? "block" : "none" }}>
                  <Annex5a
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                  />
                </div>

                <div style={{ display: selectedTable?.value === "table_5b" ? "block" : "none" }}>
                  <Annex5b
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                    regionName={selectedRegion}
                  />
                </div>

                <div style={{ display: selectedTable?.value === "table_7" ? "block" : "none" }}>
                  {(dataElements && categories && districtWideConstant) && (
                    <Annex6a
                      year={selectedYear?.value}
                      district={selectedDistrict?.value}
                      categories={categories}
                      dataElements={dataElements}
                      districtWideConstant={districtWideConstant}
                      economicDataElements={economicDataElements}
                      socialDataElements={socialDataElements}
                      period={selectedPeriod?.value}
                      hideTableDis={hideTableDis}
                    />
                  )}
                </div>

                <div style={{ display: selectedTable?.value === "table_8" ? "block" : "none" }}>
                  <Annex7a
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                  />
                </div>

                <div style={{ display: selectedTable?.value === "table_9" ? "block" : "none" }}>
                  <Annex8a
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                  />
                </div>

                <div style={{ display: selectedTable?.value === "table_10" ? "block" : "none" }}>
                  <Annex8b
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                  />
                </div>

                <div style={{ display: selectedTable?.value === "table_11" ? "block" : "none" }}>
                  <Annex8c
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                  />
                </div>

                <div style={{ display: selectedTable?.value === "table_12" ? "block" : "none" }}>
                  <Annex9a
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                  />
                </div>

              </div>
            )}

            {hasSelectedDistrict && !embedded && (
              <>

                <Col span={10} className="gutter-row">
                  {submitToNdpcAction}
                </Col>

                <Col span={10} className="gutter-row">
                  {closeReportAction}
                </Col>

                <div style={{ textAlign: "right" }}>
                  {downloadReportAction}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );

  if (embedded) {
    return <div className="main-content space-y-6 apr-report-page">{reportContent}</div>;
  }

  return (
    <div className="page-content apr-report-page">
      {reportContent}
    </div>
  );
}

export default AprReport;